import React, { useContext, useState } from 'react';

interface DataExportContextType {
    openDataExports: () => void;
    closeDataExports: () => void;
    isDataExportsOpen: boolean;
}

const DataExportContext = React.createContext<DataExportContextType>({
    openDataExports: () => { return },
    closeDataExports: () => { return },
    isDataExportsOpen: false,
});

const useDataExportsModal = () => {
    const context = useContext(DataExportContext);
    if (!context) {
        throw new Error('useDataExports must be used within an DataExportProvider');
    }
    return context;
};

const DataExportProvider = (props: { children: React.ReactNode }) => {
    const [isDataExportsOpen, setIsDataExportsOpen] = useState(false);

    const openDataExports = () => setIsDataExportsOpen(true);
    const closeDataExports = () => setIsDataExportsOpen(false);

    return (
        <DataExportContext.Provider
            value={{
                isDataExportsOpen,
                openDataExports,
                closeDataExports,
            }}
            {...props}
        >
            {props.children}
        </DataExportContext.Provider>
    );
};

export { useDataExportsModal, DataExportProvider };
